export const CONFIG = {
    ACCOUNT_INFO_FIELD: "MEDIGO_INVENTORY_ACCOUNT_INFO",
    PHARMACY_INFO: "MEDIGO_PHARMACY_INFO",
    FLOW: 'FLOW'
}

export const FLOW = {
    PHARMACIST_FAST_UPDATE_INVENTORY: 'PHARMACIST_FAST_UPDATE_INVENTORY',
    NORMAL: 'NORMAL',
    DISTRIBUTOR: 'DISTRIBUTOR',
    PHARMACY_INVENTORY: 'PHARMACY_INVENTORY'
}